import { useMemo } from "react"

import _ from "lodash"

import { useRoadwork } from "../../hooks/queries/useRoadwork"

import * as Styled from "./RoadworkSectionDocumentList.styled"

export const RoadworkSectionDocumentList = (props) => {
    const { roadworkId } = props

    const { data } = useRoadwork(roadworkId)

    const snakedData = useMemo(() => {
        if (!data) {
            return null
        }

        const snake = obj => _.transform(obj, (acc, value, key, target) => {
            const camelKey = _.isArray(target) ? key : _.snakeCase(key)

            acc[camelKey] = _.isObject(value) ? snake(value) : value
        })

        return snake(data)
    }, [data])

    return <Styled.List documents={snakedData?.documents} />
}